import { provider } from '@/provider.js'
import createStore from '@/store'

const store = createStore(provider)

export default {
  caseTypeId: 2,
  bucketId: 7,
  allResults: [
    {
      caseTypeId: 1,
      displayName: "Case",
      iconCode: "case",
      iconSet: "fas",
      total: 234,
      cases: [
        { taskSelected: false, id: "abcdefg12345", title: "case-1", properties: { ref: 1, name: "Test1", description: "Test text", total: 12345 } },
        { taskSelected: false, id: "abcdefg12346", title: "case-2", properties: { ref: 2, name: "Test1", description: "Test text", total: 12346 } },
        { taskSelected: false, id: "abcdefg12347", title: "case-3", properties: { ref: 3, name: "Test1", description: "Test text", total: 12347 } },
        { taskSelected: false, id: "abcdefg12348", title: "case-4", properties: { ref: 4, name: "Test1", description: "Test text", total: 12348 } },
        { taskSelected: false, id: "abcdefg12349", title: "case-5", properties: { ref: 5, name: "Test1", description: "Test text", total: 12349 } },
        { taskSelected: false, id: "abcdefg1234a", title: "case-6", properties: { ref: 6, name: "Test1", description: "Test text", total: 12351 } },
        { taskSelected: false, id: "abcdefg1234b", title: "case-7", properties: { ref: 7, name: "Test1", description: "Test text", total: 12352 } },
        { taskSelected: false, id: "abcdefg1234c", title: "case-8", properties: { ref: 8, name: "Test1", description: "Test text", total: 12353 } },
        { taskSelected: false, id: "abcdefg1234d", title: "case-9", properties: { ref: 9, name: "Test1", description: "Test text", total: 12354 } },
        { taskSelected: false, id: "abcdefg1234e", title: "case-10", properties: { ref: 10, name: "Test1", description: "Test text", total: 12355 } }
      ]
    },
    {
      caseTypeId: 2,
      displayName: "Block",
      iconCode: "block",
      iconSet: "fas",
      total: 146,
      cases: [
        { taskSelected: false, id: "abcdefg1234f", title: "block-1", properties: { ref: 1, height: 10, width: 10, weight: 250, material: "Wood" } },
        { taskSelected: false, id: "abcdefg1234g", title: "block-2", properties: { ref: 2, height: 12, width: 12, weight: 280, material: "Wood" } },
        { taskSelected: false, id: "abcdefg12351", title: "block-3", properties: { ref: 3, height: 16, width: 16, weight: 120, material: "Plastic" } },
        { taskSelected: false, id: "abcdefg12352", title: "block-4", properties: { ref: 4, height: 28, width: 28, weight: 240, material: "Plastic" } },
        { taskSelected: false, id: "abcdefg12353", title: "block-5", properties: { ref: 5, height: 52, width: 52, weight: 1523, material: "Iron" } },
        { taskSelected: false, id: "abcdefg12354", title: "block-6", properties: { ref: 6, height: 104, width: 104, weight: 2250, material: "Aluminium" } },
        { taskSelected: false, id: "abcdefg12355", title: "block-7", properties: { ref: 7, height: 1, width: 1, weight: 25, material: "Wood" } },
        { taskSelected: false, id: "abcdefg12356", title: "block-8", properties: { ref: 8, height: 16, width: 32, weight: 160, material: "Plastic" } },
        { taskSelected: false, id: "abcdefg12357", title: "block-9", properties: { ref: 9, height: 10, width: 20, weight: 752, material: "Iron" } },
        { taskSelected: false, id: "abcdefg12358", title: "block-10", properties: { ref: 10, height: 20, width: 30, weight: 460, material: "Aluminium" } }
      ]
    },
    {
      caseTypeId: 3,
      displayName: "Test",
      iconCode: "test",
      iconSet: "fas",
      total: 6,
      cases: [
        { taskSelected: false, id: "abcdefg12359", title: "test-1", properties: { ref: 1, testDate: "2018-12-13T11:33:29.992Z", score: 98.6, pass: true, retest: false } },
        { taskSelected: false, id: "abcdefg1235a", title: "test-2", properties: { ref: 2, testDate: "2018-12-13T12:03:49.143Z", score: 18.2, pass: false, retest: false } },
        { taskSelected: false, id: "abcdefg1235b", title: "test-3", properties: { ref: 3, testDate: "2018-12-13T12:12:59.789Z", score: 67.9, pass: false, retest: true } },
        { taskSelected: false, id: "abcdefg1236c", title: "test-4", properties: { ref: 4, testDate: "2018-12-13T12:25:12.654Z", score: 81.6, pass: true, retest: false } },
        { taskSelected: false, id: "abcdefg1235d", title: "test-5", properties: { ref: 5, testDate: "2018-12-13T12:37:26.259Z", score: 29.1, pass: false, retest: false } },
        { taskSelected: false, id: "abcdefg1235e", title: "test-6", properties: { ref: 6, testDate: "2018-12-13T12:57:48.453Z", score: 77.9, pass: false, retest: true } }
      ]
    }
  ],
  async loadAll(caseTypeId, bucketId, page) {
    this.returnMockData(page)
  },
  async reload(page) {
    this.returnMockData(page)
  },
  searchCases() {
    this.returnMockData()
  },
  getGlobalSearch() {
    return { results: this.allResults, documents: { documents: [], total: 0 } }
  },
  getCaseTypeSearch() {
    return this.allResults[0]
  },
  globalSearchSetup(result) {
    const caseType = result.caseType
    var cases = []
    var headers = []
    switch (result.caseTypeId) {
      case 1:
        cases = [
          { taskSelected: false, id: "abcdefg12345", title: { value: "case-1", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 1, name: "Test1", description: "Test text", total: 12345 },
          { taskSelected: false, id: "abcdefg12346", title: { value: "case-2", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 2, name: "Test1", description: "Test text", total: 12346 },
          { taskSelected: false, id: "abcdefg12347", title: { value: "case-3", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 3, name: "Test1", description: "Test text", total: 12347 },
          { taskSelected: false, id: "abcdefg12348", title: { value: "case-4", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 4, name: "Test1", description: "Test text", total: 12348 },
          { taskSelected: false, id: "abcdefg12349", title: { value: "case-5", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 5, name: "Test1", description: "Test text", total: 12349 },
          { taskSelected: false, id: "abcdefg1234a", title: { value: "case-6", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 6, name: "Test1", description: "Test text", total: 12351 },
          { taskSelected: false, id: "abcdefg1234b", title: { value: "case-7", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 7, name: "Test1", description: "Test text", total: 12352 },
          { taskSelected: false, id: "abcdefg1234c", title: { value: "case-8", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 8, name: "Test1", description: "Test text", total: 12353 },
          { taskSelected: false, id: "abcdefg1234d", title: { value: "case-9", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 9, name: "Test1", description: "Test text", total: 12354 },
          { taskSelected: false, id: "abcdefg1234e", title: { value: "case-10", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 10, name: "Test1", description: "Test text", total: 12355 }
        ]
        headers = [
          { text: "Title", value: "title", hasLink: true, rightAlign: false, sortable: true },
          { text: "Reference", value: "ref", hasLink: false, rightAlign: false, sortable: true },
          { text: "Name", value: "name", hasLink: false, rightAlign: false, sortable: true },
          { text: "Description", value: "description", hasLink: false, rightAlign: false, sortable: false },
          { text: "Total", value: "total", hasLink: false, rightAlign: true, sortable: true }
        ]
        break
      case 2:
        cases = [
          { taskSelected: false, id: "abcdefg1234f", title: { value: "block-1", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 1, height: 10, width: 10, weight: 250, material: "Wood" },
          { taskSelected: false, id: "abcdefg1234g", title: { value: "block-2", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 2, height: 12, width: 12, weight: 280, material: "Wood" },
          { taskSelected: false, id: "abcdefg12351", title: { value: "block-3", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 3, height: 16, width: 16, weight: 120, material: "Plastic" },
          { taskSelected: false, id: "abcdefg12352", title: { value: "block-4", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 4, height: 28, width: 28, weight: 240, material: "Plastic" },
          { taskSelected: false, id: "abcdefg12353", title: { value: "block-5", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 5, height: 52, width: 52, weight: 1523, material: "Iron" },
          { taskSelected: false, id: "abcdefg12354", title: { value: "block-6", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 6, height: 104, width: 104, weight: 2250, material: "Aluminium" },
          { taskSelected: false, id: "abcdefg12355", title: { value: "block-7", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 7, height: 1, width: 1, weight: 25, material: "Wood" },
          { taskSelected: false, id: "abcdefg12356", title: { value: "block-8", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 8, height: 16, width: 32, weight: 160, material: "Plastic" },
          { taskSelected: false, id: "abcdefg12357", title: { value: "block-9", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 9, height: 10, width: 20, weight: 752, material: "Iron" },
          { taskSelected: false, id: "abcdefg12358", title: { value: "block-10", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 10, height: 20, width: 30, weight: 460, material: "Aluminium" }
        ]
        headers = [
          { text: "Title", value: "title", hasLink: true, rightAlign: false, sortable: true },
          { text: "Reference", value: "ref", hasLink: false, rightAlign: false, sortable: true },
          { text: "Height", value: "height", hasLink: false, rightAlign: true, sortable: true },
          { text: "Width", value: "width", hasLink: false, rightAlign: true, sortable: true },
          { text: "Weight", value: "weight", hasLink: false, rightAlign: true, sortable: true },
          { text: "Material", value: "material", hasLink: false, rightAlign: false, sortable: true }
        ]
        break
      case 3:
        cases = [
          { taskSelected: false, id: "abcdefg12359", title: { value: "test-1", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 1, testDate: "2018-12-13T11:33:29.992Z", score: 98.6, pass: true, retest: false },
          { taskSelected: false, id: "abcdefg1235a", title: { value: "test-2", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 2, testDate: "2018-12-13T12:03:49.143Z", score: 18.2, pass: false, retest: false },
          { taskSelected: false, id: "abcdefg1235b", title: { value: "test-3", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 3, testDate: "2018-12-13T12:12:59.789Z", score: 67.9, pass: false, retest: true },
          { taskSelected: false, id: "abcdefg1236c", title: { value: "test-4", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 4, testDate: "2018-12-13T12:25:12.654Z", score: 81.6, pass: true, retest: false },
          { taskSelected: false, id: "abcdefg1235d", title: { value: "test-5", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 5, testDate: "2018-12-13T12:37:26.259Z", score: 29.1, pass: false, retest: false },
          { taskSelected: false, id: "abcdefg1235e", title: { value: "test-6", route: { name: "Case", params: { case_id: "343642a463424e356342bc456342" } } }, ref: 6, testDate: "2018-12-13T12:57:48.453Z", score: 77.9, pass: false, retest: true }
        ]
        headers = [
          { text: "Title", value: "title", hasLink: true, rightAlign: false, sortable: true },
          { text: "Reference", value: "ref", hasLink: false, rightAlign: false, sortable: true },
          { text: "Tested On", value: "testDate", hasLink: false, rightAlign: false, sortable: true },
          { text: "Score", value: "score", hasLink: false, rightAlign: true, sortable: true },
          { text: "Passed", value: "pass", hasLink: false, rightAlign: false, sortable: false },
          { text: "Retest?", value: "retest", hasLink: false, rightAlign: false, sortable: false }
        ]
        break
      default:
        cases = result.cases
        headers = [{ text: "Title", value: "title", hasLink: true, rightAlign: false, sortable: true }]
        break
    }
    return { caseType, cases, headers }
  },
  caseTypeSearchSetup(result) {
    const newResult = this.globalSearchSetup(result)
    newResult.caseType = {

    }
    return newResult
  },

  returnMockData(page) {
    const cases = this.claims

    const start = (5 * (page + 1)) - 5
    let end = (5 * (page + 1))
    if (end > cases.length) {
      end = cases.length
    } // prevent end being out of range
    const caseType = this.bucket.case_type
    const bucket = this.bucket
    const headers = this.headers
    const currentCases = cases.slice(start, end)
    const schema = this.schema
    store.dispatch("startBucketLoading")
    store.dispatch("setupBucket", {
      caseType,
      bucket,
      headers,
      currentCases,
      schema
    })
    store.dispatch("stopBucketLoading")
  },
  headers: [{
    text: "Title",
    value: "title",
    sortable: true,
    hasLink: true,
    rightAlign: false
  }, {
    text: "Created at",
    value: "created_at",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Updated at",
    value: "updated_at",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Current state",
    value: "current_state",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender name",
    value: "lender_name",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender address line 1",
    value: "lender_address_line_1",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 1",
    value: "answer_1",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 2",
    value: "answer_2",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 3",
    value: "answer_3",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 4",
    value: "answer_4",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 5",
    value: "answer_5",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 6",
    value: "answer_6",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 7",
    value: "answer_7",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 8",
    value: "answer_8",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 9",
    value: "answer_9",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Answer 10",
    value: "answer_10",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Date claim made",
    value: "date_claim_made",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Customer",
    value: "customer",
    sortable: true,
    hasLink: true,
    rightAlign: false
  }, {
    text: "Customer ref",
    value: "customer_ref",
    sortable: true,
    hasLink: false,
    rightAlign: true
  }, {
    text: "Documents",
    value: "documents",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Claim sent",
    value: "claim_sent",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Questionnaire sent with claim",
    value: "questionnaire_sent_with_claim",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Interest included",
    value: "interest_included",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Claim ref",
    value: "claim_ref",
    sortable: true,
    hasLink: false,
    rightAlign: true
  }, {
    text: "Claim details",
    value: "claim_details",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Claim type",
    value: "claim_type",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender account reference",
    value: "lender_account_reference",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender address line 2",
    value: "lender_address_line_2",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender address line 3",
    value: "lender_address_line_3",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender address line 4",
    value: "lender_address_line_4",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Lender address line 5",
    value: "lender_address_line_5",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Insolvency register number",
    value: "insolvency_register_number",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Timestamp claim sent",
    value: "timestamp_claim_sent",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Decision letter received",
    value: "decision_letter_received",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Date decision letter received",
    value: "date_decision_letter_received",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Decision reason",
    value: "decision_reason",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Rejection reason",
    value: "rejection_reason",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Refund amount",
    value: "refund_amount",
    sortable: true,
    hasLink: false,
    rightAlign: true
  }, {
    text: "Interest amount",
    value: "interest_amount",
    sortable: true,
    hasLink: false,
    rightAlign: true
  }, {
    text: "Refund decision",
    value: "refund_decision",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }, {
    text: "Case ref",
    value: "case_ref",
    sortable: true,
    hasLink: false,
    rightAlign: true
  }, {
    text: "Tasks added by user",
    value: "tasks_added_by_user",
    sortable: true,
    hasLink: false,
    rightAlign: false
  }],
  bucket: {
    id: 7,
    name: "All Claims",
    description: "All Claims",
    default: true,
    kpi: "current_state",
    advanced_query: "",
    created_at: "2018-07-31T08:05:08.000Z",
    work_type_id: 2,
    work_type: 2,
    contents: {
      statistics: {
        total: 25,
        totalUpdated24hrs: 12,
        totalCreated24hrs: 10
      }
    },
    case_type: {
      id: 2,
      type: "case_type",
      name: "Claim"
    },
    case_type_name: "Claim",
    bucket_members: [],
    owner: {
      id: 7,
      type: "user"
    },
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::User",
    bucket_groups: [],
    bucket_criterias: [],
    bucket_display_fields: [],
    bucket_sort_fields: [],
    bucket_alarms: []
  },
  schema: [{
    name: "Claim",
    fieldsets: [{
      name: "claim_summary",
      fields: [{
        name: "claim_ref",
        type: "number",
        readonly: true,
        sequence: true
      }]
    }, {
      name: "claim_details",
      fields: [{
        name: "claim_details",
        type: "string"
      }, {
        name: "date_claim_made",
        type: "date"
      }, {
        name: "customer",
        type: "relation",
        relation: "customer",
        uif: "customer_ref"
      }, {
        name: "claim_type",
        type: "string"
      }]
    }, {
      name: "lender_details",
      fields: [{
        name: "lender_name",
        type: "string"
      }, {
        name: "lender_account_reference",
        type: "string"
      }, {
        name: "lender_address_line_1",
        type: "string"
      }, {
        name: "lender_address_line_2",
        type: "string"
      }, {
        name: "lender_address_line_3",
        type: "string"
      }, {
        name: "lender_address_line_4",
        type: "string"
      }, {
        name: "lender_address_line_5",
        type: "string"
      }]
    }, {
      name: "checks",
      fields: [{
        name: "insolvency_register_number",
        type: "string"
      }]
    }, {
      name: "questionnaire_details",
      fields: [{
        name: "answer_1",
        type: "string"
      }, {
        name: "answer_2",
        type: "string"
      }, {
        name: "answer_3",
        type: "string"
      }, {
        name: "answer_4",
        type: "string"
      }, {
        name: "answer_5",
        type: "string"
      }, {
        name: "answer_6",
        type: "string"
      }, {
        name: "answer_7",
        type: "string"
      }, {
        name: "answer_8",
        type: "string"
      }, {
        name: "answer_9",
        type: "string"
      }, {
        name: "answer_10",
        type: "string"
      }]
    }, {
      name: "claims",
      fields: [{
        name: "claim_sent",
        type: "string",
        validation: "^[Y|N]$|^$",
        validation_message: "claim_sent should have a value of Y or N",
        display: "select",
        default_value: "N",
        options: ["Y", "N"]
      }, {
        name: "questionnaire_sent_with_claim",
        type: "string",
        validation: "^[Y|N]$|^$",
        validation_message: "questionnaire_sent_with_claim should have a value of Y or N",
        display: "select",
        default_value: "N",
        options: ["Y", "N"]
      }, {
        name: "timestamp_claim_sent",
        type: "date",
        format: "DD/MM/YYYY HH:mm"
      }]
    }, {
      name: "decisions",
      fields: [{
        name: "decision_letter_received",
        type: "string",
        validation: "^[Y|N]$|^$",
        validation_message: "decision_letter_received should have a value of Y or N",
        display: "select",
        options: ["Y", "N"]
      }, {
        name: "date_decision_letter_received",
        type: "date",
        format: "DD/MM/YYYY"
      }, {
        name: "decision_reason",
        type: "string"
      }, {
        name: "rejection_reason",
        type: "string"
      }]
    }, {
      name: "refunds",
      fields: [{
        name: "refund_amount",
        type: "number",
        display: "currency",
        symbol: "£"
      }, {
        name: "interest_included",
        type: "string",
        validation: "^[Y|N]$|^$",
        validation_message: "interest_included should have a value of Y or N",
        display: "select",
        default_value: "N",
        options: ["Y", "N"]
      }, {
        name: "interest_amount",
        type: "number",
        display: "currency",
        symbol: "£"
      }, {
        name: "refund_decision",
        type: "string"
      }]
    }, {
      name: "Documents",
      fields: [{
        name: "documents",
        type: "entity",
        cardinality: "oneToMany",
        item_type: "document",
        fields: [{
          name: "document_name",
          type: "string"
        }, {
          name: "inbound_or_outbound",
          type: "string",
          display: "select",
          options: ["INBOUND", "OUTBOUND"]
        }, {
          name: "document_location",
          type: "string"
        }, {
          name: "document_date",
          type: "date",
          format: "DD/MM/YYYY"
        }, {
          name: "document_notes",
          type: "string"
        }]
      }]
    }, {
      name: "references",
      fields: [{
        name: "case_ref",
        type: "number"
      }, {
        name: "customer_ref",
        type: "number"
      }]
    }, {
      name: "process_metrics",
      fields: [{
        name: "tasks_added_by_user",
        type: "boolean",
        readonly: true
      }]
    }]
  }],
  claims: [{
    _id: "5b6018432e1fc60835000154",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 6,
    lender_name: "HBOS",
    lender_address_line_1: "Amsterdam",
    title: {
      value: "Claim 13-011",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-07-09T14:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000139"
      },
      forename: "Matt",
      surname: "King",
      customer_ref: 13,
      gender: "male",
      marital_status: "widowed"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-012",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000155",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 7,
    lender_name: "HBOS",
    lender_address_line_1: "Toronto",
    title: {
      value: "Claim 13-013",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000be"
        },
        path: "/case/5b60183d2e1fc608350000be"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-07-09T15:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000140"
      },
      forename: "Janet",
      surname: "Wright",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-014",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000156",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 8,
    lender_name: "HBOS",
    lender_address_line_1: "Toronto",
    title: {
      value: "Claim 13-015",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-07-09T16:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000141"
      },
      forename: "Nicholas",
      surname: "Lopez",
      customer_ref: 13,
      gender: "male",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-016",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000157",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 9,
    lender_name: "HBOS",
    lender_address_line_1: "Paris",
    title: {
      value: "Claim 13-017",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-07-09T17:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000142"
      },
      forename: "Rebecca",
      surname: "Hill",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-018",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000158",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 11,
    lender_name: "HBOS",
    lender_address_line_1: "Paris",
    title: {
      value: "Claim 13-019",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-07-09T18:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000143"
      },
      forename: "Elaine",
      surname: "Scott",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-020",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000159",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 12,
    lender_name: "RBS",
    lender_address_line_1: "Paris",
    title: {
      value: "Claim 13-021",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-07-09T19:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000144"
      },
      forename: "Robin",
      surname: "Green",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-022",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000160",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 13,
    lender_name: "RBS",
    lender_address_line_1: "Mosco",
    title: {
      value: "Claim 13-023",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T10:25:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000145"
      },
      forename: "Emily",
      surname: "Smith",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-024",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000161",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 14,
    lender_name: "RBS",
    lender_address_line_1: "Mosco",
    title: {
      value: "Claim 13-025",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T11:45:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000146"
      },
      forename: "Graeme",
      surname: "Smith",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-026",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000162",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 15,
    lender_name: "RBS",
    lender_address_line_1: "Manchester",
    title: {
      value: "Claim 13-027",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T11:45:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000147"
      },
      forename: "Andrew",
      surname: "Smith",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-028",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000163",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 16,
    lender_name: "RBS",
    lender_address_line_1: "Manchester",
    title: {
      value: "Claim 13-029",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T12:55:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000148"
      },
      forename: "Jim",
      surname: "Smith",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-030",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000164",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 17,
    lender_name: "RBS",
    lender_address_line_1: "Newcastle",
    title: {
      value: "Claim 13-031",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T12:55:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000149"
      },
      forename: "Linda",
      surname: "Johnson",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-032",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000165",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 18,
    lender_name: "RBS",
    lender_address_line_1: "Newcastle",
    title: {
      value: "Claim 13-033",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T12:55:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000150"
      },
      forename: "Ryan",
      surname: "Johnson",
      customer_ref: 13,
      gender: "male",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-034",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000166",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 19,
    lender_name: "HSBC",
    lender_address_line_1: "London",
    title: {
      value: "Claim 13-035",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T13:55:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000151"
      },
      forename: "Vikki",
      surname: "Williams",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-036",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000167",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 19,
    lender_name: "HSBC",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-037",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T14:55:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000152"
      },
      forename: "James",
      surname: "Williams",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-038",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000168",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 20,
    lender_name: "HSBC",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-039",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T15:55:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000153"
      },
      forename: "Ian",
      surname: "Jones",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-040",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000169",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 21,
    lender_name: "HSBC",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-041",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T16:05:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000154"
      },
      forename: "Barry",
      surname: "Brown",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-042",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000170",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 22,
    lender_name: "XYZ",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-043",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T17:05:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000155"
      },
      forename: "Lorrain",
      surname: "Brown",
      customer_ref: 13,
      gender: "female",
      marital_status: "single"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-044",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000171",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 23,
    lender_name: "XYZ",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-045",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-08-09T18:05:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000156"
      },
      forename: "Claire",
      surname: "Brown",
      customer_ref: 13,
      gender: "female",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-046",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000172",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 24,
    lender_name: "XYZ",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-047",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T10:05:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000157"
      },
      forename: "George",
      surname: "Davis",
      customer_ref: 13,
      gender: "female",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-048",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000173",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 25,
    lender_name: "XYZ",
    lender_address_line_1: "Glasgow",
    title: {
      value: "Claim 13-049",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T11:05:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000158"
      },
      forename: "Chris",
      surname: "Davis",
      customer_ref: 13,
      gender: "female",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-050",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000174",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 26,
    lender_name: "XYZ",
    lender_address_line_1: "Edinburgh",
    title: {
      value: "Claim 13-051",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T12:15:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000159"
      },
      forename: "Alex",
      surname: "Davis",
      customer_ref: 13,
      gender: "male",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-052",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000175",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 27,
    lender_name: "XYZ",
    lender_address_line_1: "Edinburgh",
    title: {
      value: "Claim 13-053",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T13:15:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000160"
      },
      forename: "Jason",
      surname: "Miller",
      customer_ref: 13,
      gender: "male",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-054",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000176",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 28,
    lender_name: "WASD",
    lender_address_line_1: "Edinburgh",
    title: {
      value: "Claim 13-055",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T14:15:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000161"
      },
      forename: "Drew",
      surname: "Miller",
      customer_ref: 13,
      gender: "male",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-056",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000177",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 29,
    lender_name: "WASD",
    lender_address_line_1: "Edinburgh",
    title: {
      value: "Claim 13-057",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T15:15:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000162"
      },
      forename: "Francis",
      surname: "Wilson",
      customer_ref: 13,
      gender: "female",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-058",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }, {
    _id: "5b6018432e1fc60835000178",
    participating_teams: [7],
    current_state: "Complete",
    account_id: 30,
    lender_name: "WASD",
    lender_address_line_1: "Edinburgh",
    title: {
      value: "Claim 13-059",
      route: {
        name: "Case",
        params: {
          case_id: "5b60183d2e1fc608350000bd"
        },
        path: "/case/5b60183d2e1fc608350000bd"
      }
    },
    answer_1: "No",
    answer_2: "No",
    answer_3: "No",
    answer_4: "Yes",
    answer_5: "Yes",
    answer_6: "No",
    answer_7: "Yes",
    answer_8: "Yes",
    answer_9: "No",
    answer_10: "No",
    date_claim_made: "2018-09-09T16:15:23.700Z",
    customer: {
      _id: {
        $oid: "5b6018412e1fc60835000163"
      },
      forename: "Paul",
      surname: "Wilson",
      customer_ref: 13,
      gender: "male",
      marital_status: "married"
    },
    due_at: "2018-08-01T11:00:00.000Z",
    customer_ref: 13,
    case_type: "Claim",
    current_state_id: 9,
    schema_version: 1,
    documents: [],
    owned_by_id: 7,
    owned_by_type: "CaseBlocks::Team",
    owner_name: "Management Team",
    _title: "Claim 13-060",
    participating_users: [7],
    claim_sent: "N",
    questionnaire_sent_with_claim: "N",
    interest_included: "N",
    unread_conversations: 0,
    created_at: "23/12/2019 - 18:30",
    updated_at: "23/12/2019 - 18:30",
    version: 1,
    _documents: [],
    claim_ref: 34,
    collection: null,
    conversations: [],
    tasklists: ["5b6018432e1fc6083500014d", "5b6018432e1fc6083500014f"],
    tasks: ["5b6018432e1fc6083500014a", "5b6018432e1fc6083500014b", "5b6018432e1fc6083500014c", "5b6018432e1fc6083500014e"],
    work_type_id: 2
  }]
}
